import { render, staticRenderFns } from "./authenResult.vue?vue&type=template&id=6bb582ae&scoped=true&"
import script from "./authenResult.vue?vue&type=script&lang=js&"
export * from "./authenResult.vue?vue&type=script&lang=js&"
import style0 from "./authenResult.vue?vue&type=style&index=0&id=6bb582ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb582ae",
  null
  
)

export default component.exports